import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ClientService from 'services/ClientService';
import { CLIENTS } from '../query-keys';

export const useClientGroupsQuery = (
  options: Omit<UseQueryOptions, 'queryKey' | 'queryFn'> = {}
) => {
  return useQuery({
    queryKey: CLIENTS.GROUPS,
    queryFn: ClientService.groups,
    ...options,
  });
};
